import { HTMLAttributes } from 'react'

import Container from '@/components/base/container'
import Grid from '@/components/base/grid'
import Media, { MediaElement } from '@/components/base/media'
import MediaParallax from '@/components/base/media-parallax'
import Section from '@/components/base/section'

export type SingleMediaProps = HTMLAttributes<HTMLElement> &
  Partial<{ media: MediaElement }>

const SingleMedia = ({ media, ...props }: SingleMediaProps) => {
  return (
    <Section {...props}>
      <Container>
        <Grid>
          <div className="col-span-4 md:col-span-6 lg:col-span-12">
            <MediaParallax className="relative aspect-[1240/620] bg-havana">
              {(mediaRef) => (
                <Media ref={mediaRef} fill fit="cover" {...media} />
              )}
            </MediaParallax>
          </div>
        </Grid>
      </Container>
    </Section>
  )
}

export default SingleMedia
